import forEach from "@homer.utility/foreach";

class Node {
    constructor(property) {
        const node = document.createElement("meta");

        node.setAttribute("property", property);

        return node;
    }
}

export default class OpenGraph {
    #node = new Map();
    #current = {};

    constructor(nodes) {
        forEach(nodes, (node) => {
            this.#node.set(node.getAttribute("property"), node);
            this.#current[node.getAttribute("property")] = node.getAttribute("content");
        });

        this.update(this.#current);
    }

    get current() {
        return this.#current;
    }

    update(properties) {
        this.#current = properties;

        forEach(properties, (value, property) => {
            const node = this.#node.get(property) || this.#node.set(property, new Node(property)).get(property);

            node.setAttribute("content", value);
        });

        this.#node.forEach((node, property) => {
            if (!properties[property] && node.isConnected) {
                node.parentNode.removeChild(node);

                return;
            }

            if (!node.isConnected) {
                document.head.appendChild(node);
            }
        });
    }
}
